export function getParams (state){
    return state.params
}


// WEBPACK FOOTER //
// ./src/modules/discount-inconsistencies/getters.js